// extracted by mini-css-extract-plugin
export default {"container":"ChatList_container__Eytgi"};